/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { Link } from "react-router-dom";

import { useGetPolicyPageStyles } from "./index.styles";
import PolicyViewer from "../PolicyViewer";
import PolicyLanguageSelect from "../PolicyLanguageSelect";
import ScrollToTopButton from "../ScrollToTopButton";
import Footer1 from "../Footer/Footer";
import appLogo from "../../assets/images/svg/appLogo.svg";

const PolicyPage = ({ title, policyUrl }) => {
  const classes = useGetPolicyPageStyles();
  const [language, setLanguage] = useState("en");

  return (
    <div css={classes.page}>
      <div css={classes.container}>
        <div css={classes.header}>
          <Link to="/home" css={classes.logo}>
            <img height={38} src={appLogo} alt="money mails logo" />
          </Link>
          <PolicyLanguageSelect value={language} onChange={setLanguage} />
        </div>
        <PolicyViewer title={title} policyUrl={policyUrl} language={language} />
      </div>
      <Footer1 />
      <ScrollToTopButton />
    </div>
  );
};

export default PolicyPage;
